// extracted by mini-css-extract-plugin
export var container = "index-module--container--9GZeS";
export var companyInfoContainer = "index-module--company-info-container--kIXBU";
export var address = "index-module--address--iGB0N";
export var contacts = "index-module--contacts--R-o8+";
export var tel = "index-module--tel--o9d4L";
export var email = "index-module--email--OHHL7";
export var egg = "index-module--egg--Y0P5C";